module.exports = __webpack_public_path__ + "static/media/step2-poster.cf03d166.png";